var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":_vm.url,"show-file-list":false,"headers":_vm.headers,"on-success":_vm.handleAvatarSuccess,"before-upload":_vm.beforeAvatarUpload}},[(_vm.imageUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.imageUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }